import React, { useEffect, useState } from "react";
import "../../dailyBook.css";
import "jspdf-autotable";
import moment from "moment";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import { useDispatch, useSelector } from "react-redux";
import { RadioGroup, Radio, Container, Button } from "@mui/material";
import { InputLabel, Autocomplete, Box, styled, Grid } from "@mui/material";
import { FormControl, FormControlLabel, Stack, TextField } from "@mui/material";
import { fetchLedger } from "../ledgers/httpCalls";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";
import Loader from "../components/Loader";
import html2pdf from "html2pdf.js";

const AmountBox = styled(Box)({
  border: "1px solid #707070",
  padding: "6px",
  minWidth: "80px",
  borderRadius: "8px",
  height: "40px",
  display: "flex",
  alignItems: "center",
});

function CustomerReport() {
  const dispatch = useDispatch();
  const { ledgersNames, loading } = useSelector((state) => state.ledgersNames);

  const [state, setState] = useState({
    loading: false,
    startDate: "",
    employees: [],
    subshops: [],
    ledgers: [],
    ledgerType: "purchase",
    selectedCustomer: [],
    saleFilter: [],
    totalAmount: 0,
    pendingAmount: 0,
    endDate: "",
    value: "",
    personName: "",
    searchName: "",
    id: "",
    dataLedger:null,
    selectedLedger :null,
  });
  console.log("state", state.selectedCustomer);
  useEffect(() => {
    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
  }, []);

  const handleChange = (e, val) => {
    if (val) {
      setState((prev) => ({
        ...prev,
        personName: val.name,
        pendingAmount: 0,
        id: val._id,
        selectedLedger:val,
      }));
      getLedger(val._id);
    } else {
      setSearch((prev) => ({ ...prev, personName: "", pendingAmount: 0 }));
    }
  };

  const getLedger = async (id, val) => {
    console.log("val", val);
    const idval = state?.id ? state.id : id;
    console.log("idval", idval);
    console.log("idvalmm", state.selectedCustomer);

    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    let type =
      (val ? val : state.ledgerType) === "purchase"
        ? "getPurchaseLedgersById"
        : "getSaleLedgersById";

    const { ledger, totalAmount, pending ,dataLedger} = await fetchLedger(idval, type);
    console.log("ledger", ledger);
    console.log("dataLedger", dataLedger);

    console.log("totalAmount", totalAmount);

    setState((prev) => ({
      ...prev,
      selectedCustomer: ledger,
      saleFilter: ledger,
      totalAmount: totalAmount,
      pendingAmount: pending,
      dataLedger:dataLedger,
      loading: false,
    }));

    if (state.startDate && state.endDate) {
      filterbyDate(state.startDate, state.endDate);
    }
  };

  const filterbyDate = (start, end) => {
    if (!start) {
      toast.configure();
      toast.info("Select Start Date");
      return;
    }
    if (!end) {
      toast.configure();
      toast.info("Select Start Date");
      return;
    }
    if (!state.selectedCustomer) {
      toast.configure();
      toast.info("Select Ledger");
      return;
    }

    let found = state.saleFilter.filter((sale) => {
      if (
        moment(moment(sale?.date).format("YYYY-MM-DD")).isBetween(start, end) ||
        moment(moment(sale?.date).format("YYYY-MM-DD")).isSame(start) ||
        moment(moment(sale?.date).format("YYYY-MM-DD")).isSame(end)
      ) {
        return sale;
      }
    });

    setState((prev) => ({ ...prev, selectedCustomer: found }));
  };

  const searchLedgers = () => {
    if (state.searchName != "") {
      console.log("state", state.searchName);
      return ledgersNames.filter(
        (item) =>
          item?.name?.toLowerCase().includes(state.searchName) &&
          (item?.ledgerButtontype === state.ledgerType ||
            item.ledgerType == state.ledgerType)
      );
    } else {
      return ledgersNames.filter(
        (item) =>
          item?.ledgerButtontype === state.ledgerType ||
          item.ledgerType == state.ledgerType
      );
    }
  };

  const setValues = (e) => {
    setState((prev) => ({
      ...prev,
      ledgerType: e.target.value,
      // searchVal: "",
      // pendingAmountSale: "",
      // pendingAmountPurchase: "",
      // totalAmount: "",
      // // selectedCustomer: [],
      // startDate: "",
      // endDate: "",
    }));

    if (state.id) {
      const val = e.target.value;
      console.log("..", val);
      getLedger("", val);
    }
  };
  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setState((prev) => ({ ...prev, [name]: value }));
    if (name == "startDate") {
      if (state.endDate) {
        filterbyDate(value, state.endDate);
      }
    } else if (name == "endDate") {
      if (state.startDate) {
        filterbyDate(state.startDate, value);
      }
    }
  };

  const handleReport = () => {
    // let doc = new jsPDF();

    // doc.setFontSize(18);
    // doc.setFontStyle("bold");
    // doc.text(localStorage.getItem("company"), 50, 22);
    // doc.setFontSize(26);
    // doc.text("REPORT DETAIL", 80, 35);

    // doc.setFontSize(12);
    // doc.setFontStyle("normal");

    // doc.setFontSize(14);
    // doc.setFontStyle("bold");

    // doc.setFontSize(12);
    // doc.text("SHOP", 21, 48);

    // doc.setFontStyle("normal");
    // doc.text(localStorage.getItem("company") ?? "", 20, 55);
    // let regex = /(\S+\s+){7}/g;
    // let formattedAddress = localStorage
    //   .getItem("address")
    //   .replace(regex, "$&\n");

    // doc.text(formattedAddress ?? "", 20, 62);
    // doc.text(localStorage.getItem("phone") ?? "", 20, 74);

    // var currentDate = new Date();

    // var formattedDate =
    //   currentDate.getDate().toString().padStart(2, "0") +
    //   "-" +
    //   (currentDate.getMonth() + 1).toString().padStart(2, "0") +
    //   "-" +
    //   currentDate.getFullYear();

    // doc.text("Date:", 151, 62);

    // doc.text(formattedDate, 161, 62);

    // doc.setFontStyle("bold");
    // doc.setFontSize(10);
    // doc.text("Name", 151, 48);

    // doc.setFontStyle("normal");
    // doc.text(state?.personName ?? "", 151, 55);

    // doc.setFontSize(14);
    // doc.setFontStyle("bold");
    // doc.text("Name", 37, 90);
    // doc.text("Amt", 95, 90);
    // doc.text("Dep", 123, 90);
    // doc.text("Rem", 148, 90);
    // doc.text("Bal", 172, 90);
    // doc.text("Date", 183, 90);

    // doc.cell(5, 84, 204, 8, " ");

    // let y = 92;
    // state.selectedCustomer.map((item, index) => {
    //   doc.setFontSize(12);
    //   doc.setFontStyle("bold");
    //   doc.cell(5, y, 85, 6, " ");
    //   doc.cell(90, y, 25, 6, " ");
    //   doc.cell(115, y, 25, 6, " ");
    //   doc.cell(140, y, 23, 6, " ");
    //   doc.cell(163, y, 20, 6, " ");
    //   doc.cell(183, y, 25, 6, " ");

    //   console.log("item", item.detail);
    //   // doc.setFontSize(12);
    //   // doc.setFontStyle("normal");
    //   doc.text(item.detail, 15, y + 5, {
    //     maxWidth: 90,
    //     whiteSpace: "nowrap",
    //     overflow: "hidden",
    //     textOverflow: "ellipsis",
    //   });
    //   doc.text(item.totalAmount ? item.totalAmount.toString() : "", 100, y + 5);
    //   doc.text(
    //     item.depositedAmount ? item.depositedAmount.toString() : "",
    //     122,
    //     y + 5
    //   );
    //   doc.text(
    //     item.remainingAmount ? item.remainingAmount.toString() : "",
    //     147,
    //     y + 5
    //   );
    //   doc.text(item.balance ? item.balance.toString() : "", 167, y + 5);
    //   doc.text(item.date ? moment(item?.date).format("DD-MM-YYYY").toString() : "", 184, y + 5);

    //   y = y + 6;

    //   if (y >= 240) {
    //     doc.addPage();
    //     y = 20;
    //   }
    // });

    // y = y + 8;

    // doc.setFontSize(14);
    // doc.text("Total Amount", 125, y + 6);
    // doc.text(
    //   state.totalAmount ? state.totalAmount.toString() : "0",
    //   165,
    //   y + 6
    // );
    // doc.text("Pending", 125, y + 15);
    // doc.text(
    //   state.pendingAmount ? state.pendingAmount.toString() : "0",
    //   165,
    //   y + 15
    // );

    // y = y + 23;

    // doc.setFontSize(10);
    // // doc.text("Powered by www.hardwarepakistan.com", 68, 280);
    // // doc.text("0342-5588269", 88, 290);

    // let img = new Image();

    // let baseUrl = localStorage.getItem("base_url");

    // if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
    //   let snapshot = employeeLogo;
    //   img.src = snapshot;
    // } else {
    //   let snapshot = localStorage.getItem("base_url");
    //   img.src = snapshot;
    // }

    // doc.addImage(img, "png", 0, 0, 40, 40);

    // if (window.innerWidth <= 600) {
    //   doc.save("reciept");
    // } else {
    //   doc.autoPrint();
    //   window.open(doc.output("bloburl"), "_blank");
    // }


    const imgSrc = localStorage.getItem("base_url") || employeeLogo;
  const companyName = localStorage.getItem("company") || "";
  const phone = localStorage.getItem("phone") || "";
  const address = localStorage.getItem("address") || "";
  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}-${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${currentDate.getFullYear()}`;

  // Create HTML structure
  const htmlContent = document.createElement("div");
  htmlContent.innerHTML = `
    <div style="font-family: Arial, sans-serif; padding: 20px; max-width: 800px;">
      <div style="display: flex; align-items: center; margin-bottom: 20px;">
        <img src="${imgSrc}" alt="Logo" width="40" height="40" style="margin-right: 10px;" />
        <h2 style="text-align: center; flex: 1;">${companyName}</h2>
      </div>

      <h1 style="text-align: center; font-size: 24px; margin-bottom: 20px;">Ledger Report</h1>
            <h3 style="text-align: center; font-size: 14px; margin-bottom: 20px;">${state?.personName}</h3>
                 <h3 style="text-align: center; font-size: 14px; margin-bottom: 20px;">${state?.selectedLedger?.address}</h3>

 

      <section style="display: flex; justify-content: flex-end; margin-bottom: 20px;">
        <p style="margin-right: 20px;">Date: ${formattedDate}</p>
      </section>


      <section style="margin-top: 20px;">
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="padding: 8px; border: 1px solid #ddd;">Name</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Amt</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Dep</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Rem</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Bal</th>
              <th style="padding: 8px; border: 1px solid #ddd;">Date</th>
            </tr>
          </thead>
          <tbody>
            ${state.selectedCustomer
              .map(
                (item) => `
                <tr>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item.detail}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item.totalAmount || ""}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item.depositedAmount || ""}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item.remainingAmount || ""}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${item.balance || ""}</td>
                  <td style="padding: 8px; border: 1px solid #ddd;">${
                    item.date ? moment(item.date).format("DD-MM-YYYY") : ""
                  }</td>
                </tr>`
              )
              .join("")}
          </tbody>
        </table>
      </section>

      <section style="margin-top: 20px;">
        <p>Total Amount: ${state.totalAmount || "0"}</p>
        <p>Pending: ${state.pendingAmount || "0"}</p>
        <p>${state?.dataLedger?.depositedPurchaseTotal ? "Deposited Purchase Total" :  "Deposited Sale Total"}: ${state?.dataLedger?.depositedPurchaseTotal || state?.dataLedger?.depositedSaleTotal  || "0"}</p>
        

      </section>

      <footer style="text-align: center; font-size: 10px; margin-top: 30px;">
  
      </footer>
    </div>
  `;

  // Options for html2pdf
  const options = {
    margin: 0.5,
    filename: "report_detail.pdf",
    image: { type: "png", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  // Generate PDF
  html2pdf()
    .from(htmlContent)
    .set(options)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 100);
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
  };

  return (
    <div style={{ marginTop: "100px", position: "relative" }}>
      <div>
        <Container sx={{ background: "white", padding: "10px" }} maxWidth="lg">
          <div style={{ display: "block" }}>
            <form>
              <h2 className="green" style={{ textAlign: "center" }}>
                <b>Ledger Reports</b>
              </h2>

              <Grid container>
                <div
                  style={{
                    marginLeft: "auto",
                  }}>
                  <Link to="/inventory/admin/report">
                    <Button
                      variant="contained"
                      style={{
                        marginLeft: "auto",
                        borderRadius: "10px",
                      }}
                      color="secondary"
                      size="small">
                      <span>Back to Reports</span>
                    </Button>
                  </Link>
                </div>
              </Grid>

              <Grid
                className="mt-20 mb-20 margin-y-20"
                container
                sx={{ gap: { md: "0px", xs: "15px" } }}>
                <Grid item sm={4} xs={12} style={{ position: "relative" }}>
                  <FormControl style={{ width: "100%" }}>
                    <Autocomplete
                      size="small"
                      // value={state?.ledger?.name}
                      onChange={(e, val) => {
                        handleChange(e, val);
                      }}
                      getOptionLabel={(option) => option.name || ""}
                      id="controllable-states-demo"
                      // options={searchLedgers()}
                      options={ledgersNames}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} label="Search by Name" />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Stack
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center">
                    <InputLabel>Total Amount:</InputLabel>
                    <AmountBox>{state.totalAmount}</AmountBox>
                  </Stack>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Stack
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="center">
                    <InputLabel>
                      {state.ledgerType == "customer"
                        ? "Pending Sale Amount"
                        : "Pending Purchase Amount"}
                    </InputLabel>
                    <AmountBox>{state.pendingAmount}</AmountBox>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item md={12} cols={12}>
                  <div className="d-flex space-adj flex-column">
                    <div className="combine-div">
                      <div>
                        <label>From</label>
                        <input
                          value={state.startDate}
                          name="startDate"
                          onChange={handleInput}
                          style={{
                            background: " #EBEBEB 0% 0% no-repeat padding-box",
                            border: "1px solid #dcdcdc",
                            padding: "10px",
                            borderRadius: "1rem",
                            marginRight: "10px",
                            marginLeft: "10px",
                          }}
                          type="date"></input>
                      </div>
                      <div>
                        <label>To</label>
                        <input
                          value={state.endDate}
                          name="endDate"
                          className="mlt"
                          onChange={handleInput}
                          style={{
                            background: " #EBEBEB 0% 0% no-repeat padding-box",
                            border: "1px solid #dcdcdc",
                            padding: "10px",
                            borderRadius: "1rem",
                            marginRight: "10px",
                          }}
                          type="date"></input>
                      </div>
                    </div>

                    <FormControl>
                      <RadioGroup row name="position" value={state.ledgerType}>
                        <FormControlLabel
                          value="purchase"
                          control={<Radio />}
                          label="Purchase Khata"
                          labelPlacement="start"
                          onChange={setValues}
                        />
                        <FormControlLabel
                          value="sale"
                          control={<Radio />}
                          label="Sale Khata"
                          labelPlacement="start"
                          onChange={setValues}
                        />
                      </RadioGroup>
                    </FormControl>

                    <Button
                      variant="contained"
                      style={{
                        borderRadius: "10px",
                      }}
                      color="secondary"
                      size="small"
                      onClick={handleReport}>
                      <span>Generate Ledger Report</span>
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </form>
          </div>

          <Container
            style={{
              background: "white",
              padding: "18px",
              marginTop: "10px",
              borderRadius: "16px",
            }}
            maxWidth="md">
            <Grid container>
              <div
                style={{
                  overflowX: "auto",
                  width: "100%",
                  marginTop: "10px",
                }}>
                <table style={{ width: "100%", border: "none" }}>
                  <tbody>
                    <tr
                      style={{
                        color: "#4CAF50",
                        padding: "18px",
                        marginTop: "10px",
                        boxShadow: "0px 3px 6px #00000029",
                      }}>
                      <td>
                        {" "}
                        <th className="heads fs-8">#</th>{" "}
                      </td>
                      <th className="heads fs-8 ">Activity Name</th>
                      <th className="heads fs-8">Total Amount</th>
                      <th className="heads fs-8">Deposited</th>
                      <th className="heads fs-8">Remaining</th>
                      <th className="heads fs-8">Balance</th>
                      <th className="heads fs-8">Date</th>
                    </tr>
                  </tbody>

                  {state.selectedCustomer?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <p>{index + 1}</p>
                        </td>
                        <td>
                          <p>{item?.detail}</p>
                        </td>
                        <td>
                          <p>{item?.totalAmount}</p>
                        </td>
                        <td>
                          <p>{item?.depositedAmount}</p>
                        </td>
                        <td>
                          <p>{item?.remainingAmount}</p>
                        </td>
                        <td>
                          <p>{item?.balance}</p>
                        </td>
                        <td>
                          <p>{moment(item?.date).format("DD-MM-YYYY")}</p>
                        </td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            </Grid>

            {state.selectedCustomer?.length === 0 && (
              <div style={{ textAlign: "center" }}>
                Search to check activity details
              </div>
            )}
          </Container>
        </Container>
      </div>
      <Loader loading={state.loading || loading} />
    </div>
  );
}

export default CustomerReport;
